import 'react-phone-input-2/lib/style.css'

import PhoneInput, { PhoneInputProps } from 'react-phone-input-2'
import React, { HTMLAttributes } from 'react'

interface InputPhoneProps extends PhoneInputProps {
  value?: string
  name?: string
  countryCode?: string
}

export const InputPhone = ({
  value,
  className,
  countryCode = 'us',
  ...props
}: InputPhoneProps & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className="input-phone">
      <PhoneInput
        // defaultMask="(....) ...-...."
        // alwaysDefaultMask
        country={countryCode}
        {...props}
        value={value || ''}
        autoFormat
      />
      <style jsx>{`
        .input-phone {
          border: 1px solid var(--indigo-2);
          box-shadow: var(--depth-4);
          transition: border var(--transition), box-shadow var(--transition);
          :global(.react-tel-input .form-control) {
            width: 100%;
            height: auto;
            background-color: var(--white-100);
            font-size: 13px;
            line-height: 24px;
            padding: 8px 8px 8px 52px;
            color: var(--text);
            border: none;
            box-shadow: none;
          }
          :global(.react-tel-input .flag-dropdown) {
            background-color: var(--white-100);
            border: none;
          }
          :global(.selected-flag) {
            padding-left: 16px;
          }
        }
      `}</style>
    </div>
  )
}
